import { render, staticRenderFns } from "./PayrollObjectResponsibles.vue?vue&type=template&id=1d0891d7&scoped=true&"
import script from "./PayrollObjectResponsibles.vue?vue&type=script&lang=js&"
export * from "./PayrollObjectResponsibles.vue?vue&type=script&lang=js&"
import style0 from "./PayrollObjectResponsibles.vue?vue&type=style&index=0&id=1d0891d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0891d7",
  null
  
)

export default component.exports